import React, { Component } from 'react';
import {
    Box,
    withStyles,
} from '@material-ui/core';
import Swal from 'sweetalert2';
import BreadcrumbLayout from "../../shared/components/common/breadcrumbLayout";
import QuotePageForm from "../../shared/components/quote/quotePageForm";

const styles = theme => ({
    root: {
        padding: theme.spacing(3),
        backgroundColor: '#f8f9fa',
        minHeight: '100vh',
    },
    card: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
    },
    sectionTitle: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(2),
    },
    equipamentoCard: {
        backgroundColor: '#deeeff',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(2),
        position: 'relative',
    },
    deleteButton: {
        position: 'absolute',
        top: theme.spacing(1),
        right: theme.spacing(1),
    },
    sugestoesList: {
        maxHeight: 200,
        overflowY: 'auto',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(0.5),
        marginTop: theme.spacing(1),
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.6)',
        zIndex: 2000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    overlayCard: {
        backgroundColor: 'white',
        borderRadius: theme.spacing(1),
        padding: theme.spacing(3),
        width: 420,
        maxWidth: '95%',
        boxShadow: theme.shadows[5],
    },
    tabContainer: {
        marginTop: theme.spacing(2),
    },
    anexoList: {
        maxHeight: 200,
        overflowY: 'auto',
    },
    actionButtons: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(4),
        gap: theme.spacing(2),
    },
    table: {
        minWidth: 650,
    },
    tableHeader: {
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold',
    },
    searchField: {
        marginBottom: theme.spacing(2),
    },
    textArea: {
        width: '100%',
        padding: theme.spacing(1),
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.spacing(0.5),
        fontFamily: 'inherit',
        fontSize: 'inherit',
    },
});

class AdminQuotePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orcamentoAtual: { equipamentos: [], id: null },
            servicosCache: {},
            equipamentosCliente: [],
            buscaEquipamento: '',
            sugestoesEquipamento: [],
            modalItensAberto: false,
            overlayAberto: false,
            tabAnexosAtiva: 0,
            overlayEquipId: null,
            overlayItem: null,
            overlayQtd: 1,
            overlayObs: '',
            overlayPreco: '0',
            orcCliente: '',
            orcTecnico: '',
            orcStatus: 'aguardando orçamento',
            orcTotalItens: 'R$ 0,00',
            orcDesconto: 0,
            orcTotalFinal: 'R$ 0,00',
            orcObservacoes: '',
            buscaItemModal: '',
            cliente: {
                id: 1,
                nome: 'Empresa Teste Ltda',
                email: 'contato@empresa.com'
            },
            usuario: {
                perfil: 'admin',
                nome: 'Admin User',
                id: 1
            },
            funcionario: {
                id: 1,
                nome: 'Admin User'
            },
            anexos: [],
            notasFiscais: []
        };
    }

    componentDidMount() {
        this.initOrcamento();
    }

    mockEquipamentosCliente = [
        {
            id: 1,
            nome: 'Torno Mecânico CNC',
            marca: 'CNC Master',
            modelo: 'TM-5000',
            serie: 'SN12345',
            servico_id: 1
        },
        {
            id: 2,
            nome: 'Fresa Industrial',
            marca: 'MetalWorks',
            modelo: 'F-3000',
            serie: 'SN67890',
            servico_id: 2
        },
        {
            id: 3,
            nome: 'Talabarte de Segurança',
            marca: 'Vicsa',
            modelo: 'Vic-Trip X355',
            serie: 'SN11111',
            servico_id: 3
        },
        {
            id: 4,
            nome: 'Prensa Hidráulica',
            marca: 'ForcePress',
            modelo: 'PH-2000',
            serie: 'SN22222',
            servico_id: 1
        }
    ];

    mockServicosCache = {
        1: [
            {
                id: 1,
                nome: 'Manutenção Preventiva',
                codigo_interno: 'MP001',
                tipo_item: 'procedimento',
                valor: 500.00,
                valor_2: 450.00
            },
            {
                id: 2,
                nome: 'Troca de Rolamento',
                codigo_interno: 'PEC001',
                tipo_item: 'peca',
                valor: 150.00,
                valor_2: 120.00
            },
            {
                id: 3,
                nome: 'Alinhamento Eixo Principal',
                codigo_interno: 'PROC002',
                tipo_item: 'procedimento',
                valor: 300.00,
                valor_2: 250.00
            }
        ],
        2: [
            {
                id: 4,
                nome: 'Calibração de Precisão',
                codigo_interno: 'CAL001',
                tipo_item: 'procedimento',
                valor: 300.00,
                valor_2: 250.00
            },
            {
                id: 5,
                nome: 'Engrenagem Helicoidal',
                codigo_interno: 'PEC002',
                tipo_item: 'peca',
                valor: 200.00,
                valor_2: 180.00
            }
        ],
        3: [
            {
                id: 6,
                nome: 'Inspeção de Segurança',
                codigo_interno: 'INS001',
                tipo_item: 'procedimento',
                valor: 100.00,
                valor_2: 80.00
            },
            {
                id: 7,
                nome: 'Troca de Gancho',
                codigo_interno: 'PEC003',
                tipo_item: 'peca',
                valor: 75.00,
                valor_2: 60.00
            }
        ]
    };

    mockAnexos = [
        { id: 1, nome: 'Laudo Técnico.pdf', nome_arquivo: 'laudo1.pdf' },
        { id: 2, nome: 'Fotos Equipamento.zip', nome_arquivo: 'fotos.zip' }
    ];

    mockNotasFiscais = [
        {
            id: 1,
            nome: 'NF-001/2024',
            nome_arquivo: 'nf001.pdf',
            data_emissao: '2024-01-15'
        },
        {
            id: 2,
            nome: 'NF-002/2024',
            nome_arquivo: 'nf002.pdf',
            data_emissao: '2024-01-20'
        }
    ];

    initOrcamento = () => {
        this.setState({
            equipamentosCliente: this.mockEquipamentosCliente,
            servicosCache: this.mockServicosCache,
            orcCliente: this.state.cliente.nome,
            orcTecnico: this.state.usuario.nome,
            anexos: this.mockAnexos,
            notasFiscais: this.mockNotasFiscais
        });

        const orcamentoEditId = localStorage.getItem('orcamento_edit');
        if (orcamentoEditId) {
            this.carregarOrcamentoAdmin(orcamentoEditId);
        }
    };

    carregarOrcamentoAdmin = (id) => {
        const mockOrcamentoExistente = {
            id: id,
            cliente_nome: this.state.cliente.nome,
            tecnico_nome: this.state.usuario.nome,
            status: 'aguardando orçamento',
            observacoes: 'Orçamento de manutenção preventiva',
            equipamentos: [
                {
                    id: 1,
                    nome: 'Torno Mecânico CNC',
                    marca: 'CNC Master',
                    modelo: 'TM-5000',
                    serie: 'SN12345',
                    servico_id: 1,
                    itens: [
                        {
                            id: 1,
                            nome: 'Manutenção Preventiva',
                            codigo: 'MP001',
                            tipo: 'procedimento',
                            qtd: 1,
                            preco: 500.00,
                            obs: ''
                        },
                        {
                            id: 2,
                            nome: 'Troca de Rolamento',
                            codigo: 'PEC001',
                            tipo: 'peca',
                            qtd: 2,
                            preco: 150.00,
                            obs: 'Rolamento axial'
                        }
                    ]
                }
            ]
        };

        this.setState({
            orcamentoAtual: mockOrcamentoExistente,
            orcStatus: mockOrcamentoExistente.status,
            orcObservacoes: mockOrcamentoExistente.observacoes || ''
        }, () => {
            this.atualizarResumoFinanceiro();
        });
    };

    handleBuscaEquipamentoChange = (event) => {
        const termo = event.target.value;
        this.setState({ buscaEquipamento: termo });

        if (termo.length < 2) {
            this.setState({ sugestoesEquipamento: [] });
            return;
        }

        if (!this.state.equipamentosCliente || this.state.equipamentosCliente.length === 0) {
            this.setState({ sugestoesEquipamento: [] });
            return;
        }

        const sugestoes = this.state.equipamentosCliente.filter(eq =>
            eq.nome.toLowerCase().includes(termo.toLowerCase()) ||
            eq.id.toString() === termo ||
            (eq.marca && eq.marca.toLowerCase().includes(termo.toLowerCase())) ||
            (eq.modelo && eq.modelo.toLowerCase().includes(termo.toLowerCase()))
        ).slice(0, 10);

        this.setState({ sugestoesEquipamento: sugestoes });
    };

    handleBuscaEquipamentoFocus = () => {
        if (this.state.buscaEquipamento.length < 2 &&
            this.state.equipamentosCliente &&
            this.state.equipamentosCliente.length > 0) {
            this.setState({
                sugestoesEquipamento: this.state.equipamentosCliente.slice(0, 10)
            });
        }
    };

    adicionarEquipamento = (equipamento) => {
        const { orcamentoAtual } = this.state;

        if (!equipamento || !equipamento.id) {
            console.error('Equipamento inválido:', equipamento);
            return;
        }

        if (orcamentoAtual.equipamentos.find(e => e.id === equipamento.id)) {
            const { currentLanguage } = this.props;
            Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_attention_title, currentLanguage.bepiService.admin.admin_quote_swal_equipment_already_added, 'warning');
            return;
        }

        const novoEquipamento = {
            id: equipamento.id,
            servico_id: equipamento.servico_id,
            nome: equipamento.nome,
            marca: equipamento.marca,
            modelo: equipamento.modelo,
            serie: equipamento.serie,
            itens: []
        };

        this.setState(prevState => ({
            orcamentoAtual: {
                ...prevState.orcamentoAtual,
                equipamentos: [...prevState.orcamentoAtual.equipamentos, novoEquipamento]
            },
            buscaEquipamento: '',
            sugestoesEquipamento: []
        }));
    };

    removerEquipamento = (equipamentoId) => {
        const { currentLanguage } = this.props;
        Swal.fire({
            title: currentLanguage.bepiService.admin.admin_quote_swal_remove_equipment_title,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: currentLanguage.bepiService.admin.admin_quote_swal_yes,
            cancelButtonText: currentLanguage.bepiService.admin.admin_quote_swal_no
        }).then(result => {
            if (result.isConfirmed) {
                this.setState(prevState => ({
                    orcamentoAtual: {
                        ...prevState.orcamentoAtual,
                        equipamentos: prevState.orcamentoAtual.equipamentos.filter(e => e.id !== equipamentoId)
                    }
                }), this.atualizarResumoFinanceiro);
            }
        });
    };

    abrirModalItens = (equipId, servicoId) => {
        const { currentLanguage } = this.props;
        if (!servicoId) {
            Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_attention_title, currentLanguage.bepiService.admin.admin_quote_swal_no_service_linked, "warning");
            return;
        }

        const servico = this.state.servicosCache[servicoId];
        if (!servico) {
            Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_error_title, currentLanguage.bepiService.admin.admin_quote_swal_service_not_found, "error");
            return;
        }

        this.setState({
            modalItensAberto: true,
            overlayEquipId: equipId,
            buscaItemModal: ''
        });
    };

    fecharModalItens = () => {
        this.setState({ modalItensAberto: false });
    };

    getItensFiltrados = () => {
        const { overlayEquipId, buscaItemModal, servicosCache } = this.state;

        if (!overlayEquipId) return [];

        const equipamento = this.state.orcamentoAtual.equipamentos.find(e => e.id === overlayEquipId);
        if (!equipamento) return [];

        const servicoId = equipamento.servico_id;
        const itens = servicosCache[servicoId] || [];

        if (!buscaItemModal) return itens;

        return itens.filter(item =>
            item.nome.toLowerCase().includes(buscaItemModal.toLowerCase()) ||
            item.codigo_interno.toLowerCase().includes(buscaItemModal.toLowerCase())
        );
    };

    abrirOverlayAdicionar = (item) => {
        this.setState({
            overlayAberto: true,
            overlayItem: item,
            overlayQtd: 1,
            overlayObs: '',
            overlayPreco: item.valor.toString(),
            modalItensAberto: false
        });
    };

    fecharOverlayAdicionar = (cancelado = false) => {
        this.setState({ overlayAberto: false });

        if (cancelado) {
            this.setState({ modalItensAberto: true });
        }
    };

    confirmarOverlayAdicionar = () => {
        const { overlayEquipId, overlayItem, overlayQtd, overlayObs, overlayPreco } = this.state;

        if (!overlayItem) {
            console.error("Nenhum item em overlay.");
            return;
        }

        const preco = parseFloat(overlayPreco);

        this.selecionarItemAdmin(
            overlayEquipId,
            overlayItem,
            overlayItem.tipo_item,
            overlayQtd,
            preco,
            overlayObs
        );

        this.fecharOverlayAdicionar(false);
    };

    selecionarItemAdmin = (equipId, item, tipo, qtd, preco, obs) => {
        this.setState(prevState => {
            const equipamentos = [...prevState.orcamentoAtual.equipamentos];
            const equipIndex = equipamentos.findIndex(e => e.id === equipId);

            if (equipIndex === -1) return prevState;

            const novoItem = {
                id: item.id,
                nome: item.nome,
                codigo: item.codigo_interno,
                tipo,
                qtd: parseInt(qtd) || 1,
                preco: parseFloat(preco) || 0,
                obs: obs || '',
            };

            equipamentos[equipIndex].itens.push(novoItem);

            return {
                orcamentoAtual: {
                    ...prevState.orcamentoAtual,
                    equipamentos
                }
            };
        }, this.atualizarResumoFinanceiro);
    };

    removerItem = (equipId, itemIndex) => {
        const { currentLanguage } = this.props;
        Swal.fire({
            title: currentLanguage.bepiService.admin.admin_quote_swal_remove_item_title,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: currentLanguage.bepiService.admin.admin_quote_swal_yes,
            cancelButtonText: currentLanguage.bepiService.admin.admin_quote_swal_no
        }).then(result => {
            if (result.isConfirmed) {
                this.setState(prevState => {
                    const equipamentos = [...prevState.orcamentoAtual.equipamentos];
                    const equipIndex = equipamentos.findIndex(e => e.id === equipId);

                    if (equipIndex !== -1) {
                        equipamentos[equipIndex].itens.splice(itemIndex, 1);
                    }

                    return {
                        orcamentoAtual: {
                            ...prevState.orcamentoAtual,
                            equipamentos
                        }
                    };
                }, this.atualizarResumoFinanceiro);
            }
        });
    };

    atualizarResumoFinanceiro = () => {
        const { orcamentoAtual, orcDesconto } = this.state;

        let totalItens = 0;
        orcamentoAtual.equipamentos.forEach(eq => {
            eq.itens.forEach(item => {
                totalItens += (item.qtd || 1) * (item.preco || 0);
            });
        });

        const totalFinal = totalItens - orcDesconto;

        const orcamentoAtualizado = {
            ...orcamentoAtual,
            valor: totalItens,
            desconto: orcDesconto,
            totalFinal: totalFinal
        };

        this.setState({
            orcamentoAtual: orcamentoAtualizado,
            orcTotalItens: this.formatarMoeda(totalItens),
            orcTotalFinal: this.formatarMoeda(totalFinal)
        });
    };

    handleDescontoChange = (event) => {
        const desconto = parseFloat(event.target.value) || 0;
        this.setState({ orcDesconto: desconto }, this.atualizarResumoFinanceiro);
    };

    handleTabChange = (event, newValue) => {
        this.setState({ tabAnexosAtiva: newValue });
    };

    uploadAnexo = () => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '*/*';
        input.onchange = (e) => this.enviarAnexo(e.target.files);
        input.click();
    };

    enviarAnexo = (files) => {
        const { currentLanguage } = this.props;
        Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_success_title, currentLanguage.bepiService.admin.admin_quote_swal_attachment_sent, 'success');
    };

    uploadNota = () => {
        const { currentLanguage } = this.props;
        Swal.fire({
            title: currentLanguage.bepiService.admin.admin_quote_swal_add_nf_title,
            html: `
                <input type="text" id="nf_nome" class="swal2-input" placeholder="${currentLanguage.bepiService.admin.admin_quote_swal_nf_name_placeholder}">
                <label for="nf_data" class="swal2-input-label">Data de Emissão</label>
                <input type="date" id="nf_data" class="swal2-input">
            `,
            showCancelButton: true,
            confirmButtonText: currentLanguage.bepiService.admin.admin_quote_swal_select_file,
            cancelButtonText: currentLanguage.bepiService.admin.admin_quote_swal_cancel,
            preConfirm: () => {
                const nome = document.getElementById('nf_nome').value.trim();
                const data = document.getElementById('nf_data').value;
                if (!nome || !data) {
                    Swal.showValidationMessage(currentLanguage.bepiService.admin.admin_quote_swal_validation_nf);
                    return false;
                }
                return { nome, data };
            }
        }).then(result => {
            if (result.isConfirmed) {
                const input = document.createElement('input');
                input.type = 'file';
                input.accept = 'application/pdf';
                input.onchange = (e) => this.enviarNota(e.target.files, result.value.nome, result.value.data);
                input.click();
            }
        });
    };

    enviarNota = (files, nome, data_emissao) => {
        const { currentLanguage } = this.props;
        Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_success_title, currentLanguage.bepiService.admin.admin_quote_swal_nf_sent, 'success');
    };

    excluirAnexo = (anexoId) => {
        const { currentLanguage } = this.props;
        Swal.fire({
            title: currentLanguage.bepiService.admin.admin_quote_swal_remove_attachment_title,
            text: currentLanguage.bepiService.admin.admin_quote_swal_action_undone_text,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: currentLanguage.bepiService.admin.admin_quote_swal_confirm_remove,
            cancelButtonText: currentLanguage.bepiService.admin.admin_quote_swal_cancel
        }).then(result => {
            if (result.isConfirmed) {
                this.setState(prevState => ({
                    anexos: prevState.anexos.filter(a => a.id !== anexoId)
                }));
                Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_success_title, currentLanguage.bepiService.admin.admin_quote_swal_attachment_removed, 'success');
            }
        });
    };

    excluirNota = (notaId) => {
        const { currentLanguage } = this.props;
        Swal.fire({
            title: currentLanguage.bepiService.admin.admin_quote_swal_remove_nf_title,
            text: currentLanguage.bepiService.admin.admin_quote_swal_action_undone_text,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: currentLanguage.bepiService.admin.admin_quote_swal_confirm_remove,
            cancelButtonText: currentLanguage.bepiService.admin.admin_quote_swal_cancel
        }).then(result => {
            if (result.isConfirmed) {
                this.setState(prevState => ({
                    notasFiscais: prevState.notasFiscais.filter(n => n.id !== notaId)
                }));
                Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_success_title, currentLanguage.bepiService.admin.admin_quote_swal_nf_removed, 'success');
            }
        });
    };

    formatarMoeda = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
        }).format(valor);
    };

    formatarData = (data) => {
        if (!data) return '-';
        return new Date(data).toLocaleDateString('pt-BR');
    };

    salvarOuAtualizarOrcamentoAdmin = async () => {
        const { currentLanguage } = this.props;
        const { orcamentoAtual, orcStatus, orcDesconto, orcObservacoes, cliente, usuario } = this.state;

        if (!orcamentoAtual.equipamentos.length) {
            Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_error_title, currentLanguage.bepiService.admin.admin_quote_swal_no_equipments_error, "error");
            return;
        }

        try {
            let totalItens = 0;
            orcamentoAtual.equipamentos.forEach(eq => {
                eq.itens.forEach(item => {
                    totalItens += (item.qtd || 1) * (item.preco || 0);
                });
            });
            const totalFinal = totalItens - orcDesconto;

            if (!orcamentoAtual.id) {
                const { currentLanguage } = this.props;
                const confirm = await Swal.fire({
                    title: currentLanguage.bepiService.admin.admin_quote_swal_generate_quote_title,
                    text: currentLanguage.bepiService.admin.admin_quote_swal_generate_quote_text,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: currentLanguage.bepiService.admin.admin_quote_swal_generate_quote_confirm,
                    cancelButtonText: currentLanguage.bepiService.admin.admin_quote_swal_cancel,
                    confirmButtonColor: "#198754",
                    cancelButtonColor: "#dc3545"
                });

                if (!confirm.isConfirmed) {
                    return;
                }
            }

            Swal.fire({
                icon: "success",
                title: currentLanguage.bepiService.admin.admin_quote_swal_quote_saved_success,
                timer: 2000,
                showConfirmButton: false
            }).then(() => {
                window.location.hash = "home";
            });

        } catch (err) {
            console.error("Erro ao salvar orçamento:", err);
            const { currentLanguage } = this.props;
            Swal.fire(currentLanguage.bepiService.admin.admin_quote_swal_error_title, currentLanguage.bepiService.admin.admin_quote_swal_save_error, "error");
        }
    };

    render() {
        const { classes } = this.props;
        const { currentLanguage } = this.props;
        const breadcrumbItems = [
            { label: currentLanguage.bepiService.shared.shared_breadcrumb_home, path: '/bepi/admin' },
            // { label: currentLanguage.bepiService.admin.admin_breadcrumb_quotations, path: '/bepi/admin/quotations' },
            { label: currentLanguage.bepiService.admin.admin_breadcrumb_quote },
        ];

        return (
            <BreadcrumbLayout
                title={currentLanguage.bepiService.admin.admin_breadcrumb_quote}
                breadcrumbItems={breadcrumbItems}
                currentLanguage={currentLanguage}
                showBackButton
            >
                <Box className={classes.root}>
                    <QuotePageForm
                        // Dados básicos
                        cliente={this.state.orcCliente}
                        tecnico={this.state.orcTecnico}
                        status={this.state.orcStatus}
                        onStatusChange={(e) => this.setState({ orcStatus: e.target.value })}

                        // Estado da busca
                        buscaEquipamento={this.state.buscaEquipamento}
                        sugestoesEquipamento={this.state.sugestoesEquipamento}
                        onSearchChange={this.handleBuscaEquipamentoChange}
                        onSearchFocus={this.handleBuscaEquipamentoFocus}
                        onSelectEquipment={this.adicionarEquipamento}

                        // Equipamentos do orçamento
                        equipamentosOrcamento={this.state.orcamentoAtual.equipamentos}
                        onAddItem={this.abrirModalItens}
                        onRemoveEquipment={this.removerEquipamento}
                        onRemoveItem={this.removerItem}

                        // Dados financeiros
                        totalItens={parseFloat(this.state.orcTotalItens.replace('R$', '').replace('.', '').replace(',', '.')) || 0}
                        desconto={this.state.orcDesconto}
                        totalFinal={parseFloat(this.state.orcTotalFinal.replace('R$', '').replace('.', '').replace(',', '.')) || 0}
                        onDescontoChange={this.handleDescontoChange}

                        // Modal de itens
                        modalItensAberto={this.state.modalItensAberto}
                        buscaItemModal={this.state.buscaItemModal}
                        onBuscaItemModalChange={(e) => this.setState({ buscaItemModal: e.target.value })}
                        itensFiltrados={this.getItensFiltrados()}
                        onFecharModalItens={this.fecharModalItens}
                        onAbrirOverlay={this.abrirOverlayAdicionar}

                        // Overlay
                        overlayAberto={this.state.overlayAberto}
                        overlayItem={this.state.overlayItem}
                        overlayQtd={this.state.overlayQtd}
                        overlayObs={this.state.overlayObs}
                        overlayPreco={this.state.overlayPreco}
                        onOverlayQtdChange={(e) => this.setState({ overlayQtd: parseInt(e.target.value) || 1 })}
                        onOverlayObsChange={(e) => this.setState({ overlayObs: e.target.value })}
                        onOverlayPrecoChange={(e) => this.setState({ overlayPreco: e.target.value })}
                        onFecharOverlay={() => this.fecharOverlayAdicionar(true)}
                        onConfirmarOverlay={this.confirmarOverlayAdicionar}

                        // Anexos
                        tabAnexosAtiva={this.state.tabAnexosAtiva}
                        anexos={this.state.anexos}
                        notasFiscais={this.state.notasFiscais}
                        onTabAnexosChange={this.handleTabChange}
                        onUploadAnexo={this.uploadAnexo}
                        onUploadNota={this.uploadNota}
                        onExcluirAnexo={this.excluirAnexo}
                        onExcluirNota={this.excluirNota}

                        // Ações
                        onSaveQuote={this.salvarOuAtualizarOrcamentoAdmin}
                        userRole="admin"
                        currentLanguage={currentLanguage}
                        classes={classes}
                    />
                </Box>
            </BreadcrumbLayout>
        );
    }
}

export default withStyles(styles)(AdminQuotePage);
